import styles from './line-header.module.scss';

export type LineHeaderProps = {
  text?: string;
};

export const LineHeader = ({ text }: LineHeaderProps) => (
  <h2 className={styles.header} data-testid="line-header">
    {text && (
      <span className={styles.span} data-testid="line-header-text">
        {text}
      </span>
    )}
  </h2>
);
